import { isDefined } from '@e-socna/utils';

import type { FileOrBlob } from '../types/file-or-blob.type';

export const checkIfIsFileOrBlob = (value: unknown): value is FileOrBlob =>
  (isDefined(File) && value instanceof File) ||
  (isDefined(Blob) && value instanceof Blob);
